import { render } from "./App.vue?vue&type=template&id=f59e0638"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f59e0638&lang=scss"
script.render = render

export default script